const selector = {
    btnCardDelete: '.js_card_delete',
    btnCardDefault: '.js_default_card',
    btnChangeDefault: '.card-non-default-label',
    checkTerms: '#check_terms',
    btnSubmitMK: '#btn_submit_mk',
    checkTermsME: '#check_terms_me',
    btnSubmitME: '#btn_submit_me',
    checkConsentHR: '#check_consent_hr',
    btnSubmitHR: '#btn_submit_hr',
    tagsHR: '.js_tag_hr',
    hrTagsSearch:     '#hr_tags_search',
    hrTagsList:       '#hr_tags_list',
    hrTagsPagination: '#hr_tags_pagination',
    hrTagsLoading:    '#hr_tags_loading',
    hrTagsConfig:     '#hr_tags_config',
};

export { selector };